import React, { useEffect, useState } from "react";

const Giroscopio = () => {
  const [orientacao, setOrientacao] = useState({
    alpha: 0,
    beta: 0,
    gamma: 0,
  });

  const [permiteSensor, setPermiteSensor] = useState(false);
  const [erro, setErro] = useState(null);

  const iniciarGiroscopio = () => {
    const handleOrientation = (event) => {
      setOrientacao({
        alpha: event.alpha?.toFixed(2),
        beta: event.beta?.toFixed(2),
        gamma: event.gamma?.toFixed(2),
      });

      // // console.log("Alpha (Z):", event.alpha);
      // // console.log("Beta (X):", event.beta);
      // // console.log("Gamma (Y):", event.gamma);
    };

    window.addEventListener("deviceorientation", handleOrientation, true);

    return () => {
      window.removeEventListener("deviceorientation", handleOrientation);
    };
  };

  useEffect(() => {
    const verificarPermissaoIOS = async () => {
      if (
        typeof DeviceMotionEvent !== "undefined" &&
        typeof DeviceMotionEvent.requestPermission === "function"
      ) {
        try {
          const resposta = await DeviceMotionEvent.requestPermission();
          if (resposta === "granted") {
            setPermiteSensor(true);
            iniciarGiroscopio();
          } else {
            setErro("Permissão negada para acessar sensores.");
          }
        } catch (err) {
          setErro("Erro ao solicitar permissão.");
        }
      } else {
        // Android ou navegadores que não exigem permissão
        setPermiteSensor(true);
        iniciarGiroscopio();
      }
    };

    verificarPermissaoIOS();
  }, []);

  return (
    <div style={{ padding: 20 }}>
      <h2>Sensor Giroscópio</h2>

      {!permiteSensor && (
        <button
          onClick={async () => {
            try {
              const resposta = await DeviceMotionEvent.requestPermission();
              if (resposta === "granted") {
                setPermiteSensor(true);
                iniciarGiroscopio();
              } else {
                setErro("Permissão negada.");
              }
            } catch {
              setErro("Erro ao solicitar permissão.");
            }
          }}
        >
          Permitir acesso aos sensores
        </button>
      )}

      {permiteSensor && (
        <div>
          <p><strong>Alpha (Z):</strong> {orientacao.alpha}°</p>
          <p><strong>Beta (X):</strong> {orientacao.beta}°</p>
          <p><strong>Gamma (Y):</strong> {orientacao.gamma}°</p>
        </div>
      )}

      {erro && <p style={{ color: "red" }}>{erro}</p>}
    </div>
  );
};

export default Giroscopio;
